import './StripCalendarBody.scss';

const StripCalendarBody = ({dates, selectedFields}) => {  

    /**
     * Determine if a calendar element is active, selected or standard
     * @param day 
     * @returns 
     */
     const getCalendarElementClassName = (day) => {
        let className = "body__strip";
        if(day.selected) className += " body__strip--selected";
        else if(day.active) className += " body__strip--active";
        return className; 
    }

    return (
        <div className="c-strip-calendar-body">
            {dates.map((day, index) => {
                return(
                    <div className={getCalendarElementClassName(day)} style={{width: `${(100/dates.length)}%`}} key={index}>
                        <div className={`c-selected-arrow ${selectedFields.arrowPushLeft ? 'c-selected-arrow--ml' : ''}`} 
                             style={{visibility: selectedFields.arrowIndex === day.number && selectedFields.arrowIndexMonth === day.month ? 'visible' : 'hidden'}}
                        >
                            <div className="selected-arrow" /> 
                        </div>
                    </div>  
                )
            })}
        </div>
    )
}

export default StripCalendarBody;